import script from "./MyVacancyCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MyVacancyCard.vue?vue&type=script&setup=true&lang=js"

import "./MyVacancyCard.vue?vue&type=style&index=0&id=1d6672f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d6672f0"]])

export default __exports__